import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  purchases: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('purchases');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.purchases.length > 0 ? action.purchases : [];  
  return updateObject(state, {
    purchases: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, purchases:[] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PURCHASES_START:
      return fetchStart(state);
    case actionTypes.FETCH_PURCHASES_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_PURCHASES_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
